var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHazard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49,
    fill: "#FF5C00",
    fillOpacity: 0.14,
    stroke: "#FF5C00",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4146 66.7373H67.6094C70.9829 66.7373 73.2319 64.1294 73.2319 61.0669C73.2319 60.1338 72.9927 59.1768 72.4902 58.2676L54.8569 27.3315C53.8042 25.4653 51.9141 24.4844 50.0239 24.4844C48.1338 24.4844 46.1958 25.4653 45.1431 27.3315L27.5098 58.3154C27.0073 59.1768 26.7681 60.1338 26.7681 61.0669C26.7681 64.1294 29.041 66.7373 32.4146 66.7373ZM32.4624 64.4404C30.4766 64.4404 29.1367 62.8613 29.1367 61.0669C29.1367 60.5645 29.2324 59.9902 29.5195 59.3682L47.1289 28.4321C47.751 27.3315 48.8755 26.8052 50.0239 26.8052C51.1484 26.8052 52.2251 27.3076 52.8711 28.4321L70.4326 59.3921C70.7437 59.9424 70.8872 60.5405 70.8872 61.0669C70.8872 62.8613 69.5234 64.4404 67.5615 64.4404H32.4624ZM50.0239 51.8315C50.7417 51.8315 51.1724 51.353 51.1963 50.5396L51.4116 38.3853C51.4355 37.5718 50.8374 36.9736 50 36.9736C49.1626 36.9736 48.5884 37.5479 48.6123 38.3613L48.8276 50.5396C48.8276 51.353 49.2822 51.8315 50.0239 51.8315ZM50.0239 58.6265C51.0527 58.6265 51.9141 57.7651 51.9141 56.7603C51.9141 55.7314 51.0527 54.894 50.0239 54.894C48.9712 54.894 48.1099 55.7554 48.1099 56.7603C48.1099 57.7651 48.9712 58.6265 50.0239 58.6265Z",
    fill: "#FF5C00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazard);
export default __webpack_public_path__ + "static/media/hazard.ec022a25.svg";
export { ForwardRef as ReactComponent };